import styled from 'styled-components';

export const SearchBox = styled.input`
  width: 400px;
  border-radius: 16px;
  border: #333 1px solid;
  font-size: 20px;
  padding: 12px 20px;

  &::placeholder {
    color: #ccc;
  }
`;
